// extracted by mini-css-extract-plugin
export var actionButton = "_kf-t";
export var buttonContainer = "_kf-0";
export var buttonContainer2 = "_kf-1";
export var buttonSection = "_kf-2";
export var details = "_kf-3";
export var dropdownItem = "_kf-5";
export var dropdownItemsContainer = "_kf-4";
export var fileInput = "_kf-r";
export var headerButton = "_kf-6";
export var icon = "_kf-7";
export var input = "_kf-8";
export var macroListItem = "_kf-9";
export var mainContent = "_kf-a";
export var microText = "_kf-b";
export var modal = "_kf-w";
export var optionsButton = "_kf-c";
export var paperclip = "_kf-s";
export var pillContent = "_kf-d";
export var preview = "_kf-e";
export var preview2 = "_kf-f";
export var quillEditor = "_kf-q";
export var selectedMacro = "_kf-g";
export var sidebar = "_kf-h";
export var sidebarHeader = "_kf-j";
export var sidebarList = "_kf-i";
export var sidebarListItem = "_kf-k";
export var sidebarSearch = "_kf-l";
export var snoozeDurationWrapper = "_kf-v";
export var statusPillContainer = "_kf-m";
export var tagsContainer = "_kf-n";
export var unselectedMacro = "_kf-o";
export var variable = "_kf-u";
export var wrapper = "_kf-p";